export default __webpack_public_path__ + "ac95fbf438778592fc5ae2579d2bdffb.svg";